import React, { useEffect, useState } from 'react';
import './index.scss';
import { transIssueDurationTime } from '@/utils/util';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';

const IssueSummary = () => {
  const { newCommon, login } = useSelector((state: RootState) => state);
  const { cockpitTeamName, teamInfo, userInfo } = newCommon;
  const { workTimeTotal, workStartTime, completeIssueCount } = userInfo || {};
  const [workTime, setWorkTime] = useState<number>(0);
  const formatTime = () => {
    const todayWorkTime = workStartTime ? Date.now() - workStartTime : 0;
    const todayWorkTimeTotal = workTimeTotal
      ? todayWorkTime + workTimeTotal * 1000
      : todayWorkTime;
    return todayWorkTimeTotal;
  };

  useEffect(() => {
    setWorkTime(formatTime());
    const interval = setInterval(() => {
      setWorkTime(formatTime());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [workTimeTotal, workStartTime]);

  return (
    <div className="record-info">
      <div className="team-work-detail">
        <div className="left-box">
          <i className="vehicle-icon"></i>
          <div className="detail-content">
            <i className="tag">团队</i>
            <i>{cockpitTeamName}</i>
          </div>
        </div>
        <div className="center">
          <i className="issue-num">{teamInfo?.completeIssueCount || 0}</i>
          <i>今日处理工单总数</i>
        </div>
        <div className="right">
          <i className="issue-num">{teamInfo?.waitAcceptIssueCount || 0}</i>
          <i>待处理工单数</i>
        </div>
      </div>
      <div className="user-work-detail">
        <div className="left-box">
          <i className="user-avatar"></i>
          <div className="detail-content">
            <i className="tag">个人</i>
            <i>{login.userInfo?.userName}</i>
          </div>
        </div>
        <div className="center">
          <i className="issue-num">{userInfo?.completeIssueCount || 0}</i>
          <i>今日工单处理量</i>
        </div>
        <div className="right">
          <i className="work-time">
            {workTime ? transIssueDurationTime(workTime) : '--'}
          </i>
          <i>今日工作时长</i>
        </div>
      </div>
    </div>
  );
};

export default IssueSummary;
